<script lang="ts">
  import back from '$lib/assets/free-trial/back.svg';
  import { translation } from '$lib/locale/locale';
  import { createEventDispatcher } from 'svelte';
  const { t } = translation();
  const dispatch = createEventDispatcher();
  export let title = '';
  export let subtitle = '';
  export let showBack = true;
  export let subheaderMarginBottom = '32px';

</script>

<div class="header">
  {#if showBack}
  <button class="back" on:click={()=> dispatch('back')}>
    <img class="back-arrow" src={back} alt="Back" />
  </button>
  {/if}
  <div class="step-title">
    {title}
  </div>
  <div></div>
</div>
<div class="subheader" style="margin-bottom: {subheaderMarginBottom};">
  {subtitle}
</div>

<style>
  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 8px;
    color: var(--text-primary);
    font-weight: var(--bold-font-weight);
    font-size: var(--md-font-size);
  }

  .subheader {
    color: var(--black-coral);
    font-size: var(--xs-font-size);
    font-weight: var(--normal-font-weight);
  }

  .back {
    background-color: #f6f7f8;
    border-radius: 4px;
    padding: 4px;
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 8px;
  }
  .back-arrow {
    width: 13px;
    height: 13px;
  }
</style>
